export const ProposalStatus = {
  WAITING: 'WAITING',
  CANCELLED: 'CANCELLED',
  FINISHED: 'FINISHED',
  ACCEPTED: 'ACCEPTED'
}



// WEBPACK FOOTER //
// ./src/constants/ProposalStatus.js